<template>
  <div class="flex flex-col gap-4">
    <V4MyVideosFilters />
    <V4MyVideosGrid />
  </div>
</template>

<script setup>
import { useMyVideosStore } from "@/stores/my-videos/my-videos.store";
import { watchDebounced } from "@vueuse/core";
import { storeToRefs } from "pinia";
import { onMounted, defineOptions } from "vue";
import V4MyVideosFilters from "./filters/V4MyVideosFilters.vue";
import V4MyVideosGrid from "./partials/V4MyVideosGrid.vue";

defineOptions({
  inheritAttrs: false,
});

const myVideosStore = useMyVideosStore();
const { sortSelection } = storeToRefs(myVideosStore);

const fetchMyVideos = async () => {
  try {
    await myVideosStore.getMyVideos();
  } catch (error) {
    console.error(error);
  }
};

const handleFilterChange = () => {
  myVideosStore.resetMyVideosList();
  fetchMyVideos();
};

watchDebounced(sortSelection, handleFilterChange, {
  debounce: 500,
});

onMounted(fetchMyVideos);
</script>

<style lang="css" scoped>
.slide-fade-enter-active {
  transition: all 0.2s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
